export const COLOR = "#00A2F9";
